module.exports = "<!--here should be search filters-->\n";